export default __webpack_public_path__ + "static/media/pma_token_bg.b24f7c91.png";